export default "__VITE_PUBLIC_ASSET__546307c1__"